interface OtpSmsError {
    error: string;
}

export type OtpSmsState = null | 'loading' | 'success' | OtpSmsError;

export function isOtpSmsInError(otpSms: OtpSmsState): otpSms is OtpSmsError {
    return otpSms && typeof otpSms !== 'string' && 'error' in otpSms;
}

export interface SeSignState {
    otpSms: OtpSmsState;
}

export const seSignInitialState: SeSignState = {
    otpSms: null,
};
